export const compareDates = (today, dueDate) => {
  return Date.parse(dueDate) > Date.parse(today);
};
